import Transforms from './transforms'

const endpoints = {
    list: {
        path: '/sources',
        transform: Transforms.list,
    },
}

export default {
    name: 'sources',
    endpoints,
}
